<template>
  <transition @enter="onEnter" @leave="onLeave" :css="false">
    <div
      v-cloak
      v-if="sharedState.activeOverlay === $options.name"
      class="menu-overlay location-nav pt5"
    >
      <background-hover :items="bgItems" ref="bgHover">
        <div class="relative z-5 grid cf">
          <div class="col-l col-10-l push-1-l">
            <nav class="location-nav__menu hover-fade-other">
              <p
                class="fw5 ttu tracked mb4"
                :class="currentLocation == 'portal' || lobbyLocation || currentLocation == 'shop' ? 'dark' : 'light'"
                data-menu-item
              >{{ translations.our_hotels }}</p>
              <ul
                class="list f1 color-2 shop-dark"
                :class="currentLocation == 'portal' || lobbyLocation || currentLocation == 'shop' ? 'portal' : ''"
              >
                <li
                  v-for="(location, i) in locations"
                  :key="i"
                  class="location-nav__menu-item list__item"
                  :class="getLocationFont(location.handle)"
                  data-menu-item
                >
                  <a
                    :href="location.url"
                    class="hover-fade-other__item"
                    :class="location.handle === currentLocation ? 'active' : null"
                    @mouseover="onMouseOver(location, `loc${i}`)"
                    @mouseleave="onMouseLeave"
                  >{{ location.name }}</a>
                </li>
              </ul>

              <p
                class="fw5 ttu tracked mb4 mt5 pt3"
                :class="currentLocation == 'portal' || lobbyLocation || currentLocation == 'shop' ? 'dark' : 'light'"
                data-menu-item
              >{{ translations.our_restaurants }}</p>
              <ul
                class="list f1 color-2 shop-dark"
                :class="currentLocation == 'portal' || lobbyLocation || currentLocation == 'shop' ? 'portal' : ''"
              >
                <li
                  v-for="(restaurant, i) in restaurants"
                  :key="i"
                  class="location-nav__menu-item list__item"
                  :class="getLocationFont(restaurant.handle)"
                  data-menu-item
                >
                  <a
                    :href="restaurant.url"
                    class="hover-fade-other__item"
                    :class="restaurant.handle === currentLocation ? 'active' : null"
                    @mouseover="onMouseOver(restaurant, `rest${i}`)"
                    @mouseleave="onMouseLeave"
                  >{{ restaurant.name }}</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </background-hover>

      <button-circle-rotating
        v-cloak
        v-if="sharedState.activeOverlay === $options.name && sharedState.isCommerceInstalled"
        :shop="this.webshop"
        :darkTheme="currentLocation == 'portal' || lobbyLocation || currentLocation == 'shop' ? 'dark' : 'light'"
      ></button-circle-rotating>
    </div>
  </transition>
</template>

<script>
import anime from "animejs"
import h from "../helpers"
import s from "../store"
import BackgroundHover from "./BackgroundHover.vue"
import ButtonCircleRotating from "./ButtonCircleRotating.vue"
import { handleMenuOverlayEnter, handleMenuOverlayLeave } from "./MenuOverlay"

export default {
  name: "LocationNav",

  components: {
    BackgroundHover,
    ButtonCircleRotating
  },

  props: {
    currentLocation: String,
    locations: Array,
    lobbyLocation: Boolean,
    restaurants: Array,
    translations: Object,
    webshop: Object
  },

  data() {
    return {
      sharedState: s.state
    }
  },

  computed: {
    bgItems: function() {
      const fn = key => (item, i) => ({ key: key + i, image: item.image })
      const locations = this.locations.map(fn("loc"))
      const restaurants = this.restaurants.map(fn("rest"))
      return locations.concat(restaurants)
    }
  },

  methods: {
    onEnter: function(el, done) {
      handleMenuOverlayEnter(el, done)
    },

    onLeave: function(el, done) {
      handleMenuOverlayLeave(el, done)
    },

    onMouseOver: h.debounce(function(location, key) {
      this.setActiveBg(key)
    }, 300),

    onMouseLeave: function() {
      this.setActiveBg(null)
    },

    setActiveBg: function(key) {
      this.$refs.bgHover.setActiveItem(key)
    },

    getLocationFont: function(handle) {
      const locationFontMap = {
        portal_nl: "font-portal",
        portal_en: "font-portal",
        hotelv_fizeaustraat_nl: "font-fizeaustraat",
        hotelv_fizeaustraat_en: "font-fizeaustraat",
        hotelv_frederiksplein_nl: "font-frederiksplein",
        hotelv_frederiksplein_en: "font-frederiksplein",
        hotelv_nesplein_nl: "font-nesplein",
        hotelv_nesplein_en: "font-nesplein",
        lobby_fizeaustraat_nl: "font-fizeaustraat",
        lobby_fizeaustraat_en: "font-fizeaustraat",
        lobby_nesplein_nl: "font-nesplein",
        lobby_nesplein_en: "font-nesplein",
        webshop_nl: "font-shop",
        webshop_en: "font-shop"
      }
      return locationFontMap.hasOwnProperty(handle)
        ? locationFontMap[handle]
        : null
    }
  }
}
</script>
